"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
(0, manifest_1.registerSection)({
    type: 'featured-collection', label: 'Featured products', icon: 'star', category: 'products',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default('Favourites this week'),
        eyebrow: zod_1.z.string().max(60).default('Handpicked'),
        columns: zod_1.z.number().int().min(2).max(5).default(4),
        limit: zod_1.z.number().int().min(1).max(24).default(8),
        productIds: zod_1.z.array(zod_1.z.string()).default([]), // empty => fall back to catalog featured
        ..._appearance_1.appearanceShape,
    }),
    defaults: () => ({ title: 'Favourites this week', eyebrow: 'Handpicked', columns: 4, limit: 8, productIds: [], ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'eyebrow', label: 'Eyebrow', control: 'text', group: 'Content' },
        { name: 'columns', label: 'Columns', control: 'number', min: 2, max: 5, group: 'Content' },
        { name: 'limit', label: 'Max products', control: 'number', min: 1, max: 24, group: 'Content' },
        { name: 'productIds', label: 'Products', control: 'product-ids', group: 'Content' },
        ..._appearance_1.appearanceFields,
    ],
});
//# sourceMappingURL=featured-collection.js.map